import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'ysm4v1yw',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skxTAPWd6CjxCGHedXVoat0G3Minn0xVHRjcRFPOMSWHN1Uqnv9IB2cHZAAe2N3euBjNPTwQ2zyDBZCrs5zUAQvhMjseOM9bWltfRiKDFFqBEj7PvuEGSw7dXyvoUcGNTOiEUP1YDEWQRefxqLw6PtbtjIQaB6DXZX72tHqwE4gsN8mhv6gL',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
